import { combineReducers } from 'redux';
import { reducer as project } from './project';
import { reducer as system } from './system';
import { reducer as language } from './language';
import { reducer as labelCollection } from './labelCollection';
import { reducer as label } from './label';
import { reducer as engine } from './engine';

export const reducers = combineReducers({
	project,
	system,
	language,
	labelCollection,
	label,
	engine
});


// WEBPACK FOOTER //
// ./React/src/reducers/index.js